// import * as types from './mutation-types'
import auth from '../services/auth'

export const login = ({ commit }, credentials) => {
  auth.login(credentials)
    // commit(types.ADD_TO_CART, {
    //   id: payload.id
    // })
}



// WEBPACK FOOTER //
// ./src/components/store/actions.js